import React from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { DocsViewer } from '../components/DocsViewer';
import { useAuthStore } from '../stores/authStore';
import '../styles/docs.css';

interface DocNavItemProps {
    to: string;
    icon: string;
    label: string;
}

const DocNavItem: React.FC<DocNavItemProps> = ({ to, icon, label }) => (
    <NavLink
        to={to}
        className={({ isActive }) => `docs-nav-item${isActive ? ' active' : ''}`}
    >
        <span className="docs-nav-icon">{icon}</span>
        <span>{label}</span>
    </NavLink>
);

const DocsPage: React.FC = () => {
    const { user } = useAuthStore();
    
    // Administrator roles map to rank >= 4 in AppShell.tsx (HeadOffice, SuperAdmin)
    const isAdmin = ['HeadOffice', 'SuperAdmin'].includes(user?.role || '');

    return (
        <div className="docs-layout">
            {/* Sidebar */}
            <aside className="docs-sidebar">
                <div className="docs-sidebar-title">
                    <span className="docs-title-icon">📖</span>
                    Platform Docs
                </div>

                {isAdmin && (
                    <>
                        <div className="docs-section-label">User Guides</div>
                        <DocNavItem to="/docs/admin" icon="👥" label="Admin Guide" />
                        <DocNavItem to="/docs/staff" icon="📋" label="Staff Guide" />
                    </>
                )}

                <div className="docs-section-label">System</div>
                <DocNavItem to="/docs/changelog" icon="📝" label="Changelog & Updates" />
            </aside>

            {/* Content */}
            <main className="docs-content">
                <Routes>
                    <Route path="/" element={<Navigate to={isAdmin ? "admin" : "changelog"} replace />} />
                    {isAdmin && (
                        <>
                            <Route path="admin" element={<DocsViewer documentName="admin-guide" />} />
                            <Route path="staff" element={<DocsViewer documentName="staff-guide" />} />
                        </>
                    )}
                    <Route path="changelog" element={<DocsViewer documentName="changelog" />} />
                </Routes>
            </main>
        </div>
    );
};

export default DocsPage;
